import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase"; // Ensure this path is correct

const Register: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showTooltip, setShowTooltip] = useState(false); // Tooltip visibility state
  const navigate = useNavigate();

  const handleRegister = async () => {
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const auth = getAuth();
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      if (!user || !user.uid) throw new Error("User not authenticated after registration.");

      // Add user to Firestore with a default role of "user"
      try {
        await setDoc(doc(db, "users", user.uid), {
          email: user.email,
          role: "user",
          isAugust: false,
          triviaAnswers: {}, // <-- Add this line
          createdAt: new Date().toISOString(),
        });
      } catch (error) {
        console.error("Registration Firestore error:", error);
      }

      console.log("User registered:", user);

      // Show the success tooltip
      setShowTooltip(true);
      setTimeout(() => {
        setShowTooltip(false); // Hide the tooltip after 3 seconds
        navigate("/"); // Redirect to login page
      }, 3000);
    } catch (error) {
      console.error("Error during registration:", error);
      setError("Failed to register. Please try again.");
    }
  };

  return (
    <div className="login-container"> {/* Use the same class as Login */}
      <h1>Register</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {showTooltip && <div className="success-tooltip">Successful register</div>}
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <input
        type="password"
        placeholder="Confirm Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <button onClick={handleRegister}>Register</button>
      <p>
        Already have an account? <Link to="/">Login here</Link>
      </p>
    </div>
  );
};

export default Register;